import React from 'react';

import { LoadableLazy } from '@confluence/loadable';

import { CommentButtonPlaceholder } from './CommentButtonPlaceholder';

export const CommentButtonLazy = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentButton" */ './CommentButton'))
			.CommentButton,
	loading: ({ isDataLoaded }) => <CommentButtonPlaceholder isDisabled={!isDataLoaded} />,
});
